<template>
    <div class="brt-filter-module" :border="border" :inline="inline">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "FilterBox",

        provide () {
            return { filterBox : this };
        },
        props: {
            itemRight: {
                type: Number
            },
            labelWidth: {
                type: Number
            },
            inline: {
                default: undefined
            },
            border: {
                default: false
            }
        }
    }
</script>

<style lang="less">
    @import "../../styles/comm.less";

    .brt-filter-module {
        .brt-filter-item-module {
            margin-bottom: @SpacingNumber;

            &:last-child {
                margin-bottom: 0;
            }
        }

        &[border] {
            border-bottom: 1px solid @BorderColorA2;
        }
        &[border='top'] {
            border-bottom: none;
            border-top: 1px solid @BorderColorA2;
        }
        &[border='top-bottom'] {
            border-top: 1px solid @BorderColorA2;
        }

        &[inline] {
            .brt-filter-item-module {
                display: inline-block;
                margin-bottom: 0;
            }
        }
    }
</style>
